import * as React from 'react';
import { FieldInputElementProps } from '../interfaces/IInputProps';
import { PPMFeatures, Subscription } from '../../../store/Tenant';
import EntityFieldInputElement from './EntityFieldInputElement';
import { ApplicationState } from '../../../store';
import { connect } from 'react-redux';

type OwnProps = FieldInputElementProps;
type StateProps = { subscription: Subscription; }
type Props = OwnProps & StateProps;

const IdeaFieldInputElement = (props: Props) => {
    const available = Subscription.contains(props.subscription, PPMFeatures.Ideation);
    return <EntityFieldInputElement
        {...props}
        readOnly={props.readOnly || !available}
        withNavigation={available}
    />;
}

const mapStateToProps = (state: ApplicationState) => ({ subscription: state.tenant.subscription });
export default connect(mapStateToProps)(IdeaFieldInputElement);